
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 81.77 81.77"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M40.89 0a40.89 40.89 0 1040.88 40.89A40.89 40.89 0 0040.88 0zm-3.22 51.4h-8.62v-21h8.62zm15 0H44.1v-21h8.62z"}})])
          )
        }
      }
    